var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333984,
    width: 40.6667,
    height: 40.6667,
    rx: 8.33333,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_27384",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66797,
    y: 8.33337,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_27384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.668 28.6601L19.5642 27.6679C17.9066 26.1641 16.5357 24.8718 15.4517 23.7911C14.3677 22.7103 13.5087 21.7484 12.8747 20.9054C12.2407 20.0626 11.7978 19.2936 11.546 18.5986C11.294 17.9038 11.168 17.1987 11.168 16.4834C11.168 15.0642 11.6465 13.8761 12.6035 12.9189C13.5606 11.9619 14.7488 11.4834 16.168 11.4834C17.041 11.4834 17.866 11.6876 18.643 12.0959C19.42 12.5042 20.095 13.0898 20.668 13.8526C21.241 13.0898 21.916 12.5042 22.693 12.0959C23.47 11.6876 24.295 11.4834 25.168 11.4834C26.5871 11.4834 27.7753 11.9619 28.7325 12.9189C29.6895 13.8761 30.168 15.0642 30.168 16.4834C30.168 17.1987 30.042 17.9038 29.79 18.5986C29.5381 19.2936 29.0952 20.0626 28.4612 20.9054C27.8272 21.7484 26.9698 22.7103 25.889 23.7911C24.8083 24.8718 23.4359 26.1641 21.7717 27.6679L20.668 28.6601ZM20.668 26.6334C22.268 25.1937 23.5846 23.9597 24.618 22.9314C25.6513 21.9032 26.468 21.01 27.068 20.2516C27.668 19.4933 28.0846 18.8199 28.318 18.2314C28.5513 17.6431 28.668 17.0604 28.668 16.4834C28.668 15.4834 28.3346 14.6501 27.668 13.9834C27.0013 13.3167 26.168 12.9834 25.168 12.9834C24.3783 12.9834 23.6485 13.2074 22.9785 13.6554C22.3086 14.1036 21.7782 14.727 21.3872 15.5256H19.9487C19.5512 14.7205 19.0191 14.0955 18.3525 13.6506C17.6858 13.2058 16.9576 12.9834 16.168 12.9834C15.1743 12.9834 14.3426 13.3167 13.6727 13.9834C13.0029 14.6501 12.668 15.4834 12.668 16.4834C12.668 17.0604 12.7846 17.6431 13.018 18.2314C13.2513 18.8199 13.668 19.4933 14.268 20.2516C14.868 21.01 15.6846 21.9016 16.718 22.9266C17.7513 23.9516 19.068 25.1872 20.668 26.6334Z",
    fill: "#F46530"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.eae3805b0ca8b944e1821427dae5392a.svg";
export { ForwardRef as ReactComponent };